(function() {
    "use strict";

    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function(text) {
            text = String(text);
            return this.length >= text.length && this.substring(this.length - text.length, this.length) == text;
        };
    }
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/String.endsWith.js